import { render, staticRenderFns } from "./caseAddEdit.vue?vue&type=template&id=47b66152"
import script from "./caseAddEdit.vue?vue&type=script&lang=js"
export * from "./caseAddEdit.vue?vue&type=script&lang=js"
import style0 from "./caseAddEdit.vue?vue&type=style&index=0&id=47b66152&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports